import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAuthenticated, mustResetPassword } from '../auth/session';

export const Route = createFileRoute('/contests')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
    if (mustResetPassword()) {
      throw redirect({ to: '/change-password' });
    }
  },
  component: Outlet,
});
